import script from "./SearchResultArticleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchResultArticleCard.vue?vue&type=script&setup=true&lang=js"

import "./SearchResultArticleCard.vue?vue&type=style&index=0&id=f5ca23be&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5ca23be"]])

export default __exports__